module.exports = __webpack_public_path__ + "img/lifeline123-main.ba7cbe10.png";